

<template>
  <div class="flex w-full">
    <div class="vx-col w-full max-auto self-center">
      <vx-card class="shadow-md">
        <div class="vx-row">
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-4 mx-auto self-center">
            <h6>Select Zone</h6>
            <v-select
              @change="makeLocationList"
              class="w-full"
              :clearable="false"
              v-model="selectedZone"
              :options="availableZones"
            ></v-select>
          </div>
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-4 mx-auto self-center">
            <h6>Select Location</h6>
            <v-select
              :disabled="selectedZone.value == 'SelectZone'"
              @change="makeModemList"
              class="w-full"
              :clearable="false"
              v-model="selectedLocation"
              :options="availableLocations"
            ></v-select>
          </div>
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-4 mx-auto self-center">
            <h6>Select Modem</h6>
            <v-select
              :disabled="selectedLocation.value == 'SelectLocation' || selectedZone.value =='SelectZone' || selectedLocation.value =='noLocation'"
              class="w-full"
              :clearable="false"
              v-model="selectedModem"
              :options="availableModems"
            ></v-select>
          </div>
          <div class="vx-col w-full mb-4 mx-auto self-center">
            <h6>Select Time Range</h6>
            <v-select
              :disabled="selectedModem.value == 'SelectModem' || selectedModem.value == '' || selectedModem.value == 'noModem'"
              class="w-full"
              :clearable="false"
              v-model="selectedTimeRange"
              :options="availableTimeRange"
            ></v-select>
          </div>
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4 mx-auto self-center"
            v-if="selectedTimeRange.value == 'custom'"
          >
            <p>Select Start Date:</p>
            <datetime
              type="datetime"
              @change="chekInputTimeValidation"
              input-class="vs-inputx vs-input--input normal"
              v-model="selectedStartDate"
            ></datetime>
          </div>
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4 mx-auto self-center"
            v-if="selectedTimeRange.value == 'custom'"
          >
            <p>Select End Date:</p>
            <datetime
              type="datetime"
              input-class="vs-inputx vs-input--input normal"
              v-model="selectedEndDate"
            ></datetime>
          </div>
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mt-2 mx-auto self-center text-center"
          >
            <vs-button
              :disabled="selectedModem.value == 'SelectModem' || selectedModem.value == '' || selectedModem.value == 'noModem'"
              class="mr-6"
              color="success"
              type="gradient"
              @click="sendData"
            >{{buttonText}}</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment-timezone";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  data() {
    return {
      availableZones: [],
      availableLocations: [],
      availableModems: [],
      selectedZone: "",
      selectedLocation: "",
      selectedModem: "",
      selectedTimeRange: "",
      buttonText: "Show Trend",
      selectedStartDate: moment()
        .subtract(5, "days")
        .format("YYYY-MM-DDTHH:mm:ss"),
      selectedEndDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
      availableTimeRange: []
    };
  },
  created() {
    var data = this.$store.state.zones;
    var zones = [];
    var timeRange = [];
    var timeData = [
      "Select Custom Time Range",
      "Last 30 min",
      "Last hour",
      "Last 4 hour",
      "Last 8 hour",
      "Last 24 hour",
      "Last 7 days",
      "Last 30 days",
      //"Last 3 Month",
      //"Last 6 Month",
      "Day so far",
      "Week so far",
      "Month so far"
      //"Year so far"
    ];

    zones.push({ label: "Select Zone", value: "SelectZone" });
    var sortedData = data.sort(function(a, b) {
      var nameA = a.name.toUpperCase(); // ignore upper and lowercase
      var nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
    for (var x in sortedData) {
      zones.push({ label: sortedData[x].name, value: sortedData[x].id });
    }
    for (var m in timeData) {
      if (timeData[m] == "Select Custom Time Range") {
        timeRange.push({ label: timeData[m], value: "custom" });
      } else {
        timeRange.push({ label: timeData[m], value: timeData[m] });
      }
    }
    this.availableTimeRange = timeRange;
    this.selectedTimeRange = timeRange[4].value;
    if (zones.length == 1) {
      zones = [];
      zones.push({ label: "No Zones Available", value: "noZone" });
      this.availableZones = zones;
      this.selectedZone = { label: "No Zones Available", value: "noZone" };
    } else {
      this.availableZones = zones;
      this.selectedZone = { label: "Select Zone", value: "SelectZone" };
    }
  },
  computed: {},
  methods: {
    makeLocationList() {
      var locations = this.$store.state.locations;
      var selectedZone = this.selectedZone.value;
      var locationsData = [];
      locationsData.push({ label: "Select Location", value: "SelectLocation" });
      var sortlocations = locations.sort(function(a, b) {
        var nameA = a.name.toUpperCase();
        var nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      for (var x in sortlocations) {
        if (sortlocations[x].locationZone == selectedZone) {
          locationsData.push({
            label: sortlocations[x].name,
            value: sortlocations[x].id
          });
        }
      }
      if (locationsData.length == 1) {
        locationsData = [];
        locationsData.push({
          label: "No Locations Available",
          value: "noLocation"
        });
        this.availableLocations = locationsData;
        this.selectedLocation = {
          label: "No Locations Available",
          value: "noLocation"
        };
      } else {
        this.availableLocations = locationsData;
        this.selectedLocation = {
          label: "Select Location",
          value: "SelectLocation"
        };
      }
      this.$emit("disableSave", true);
    },
    makeModemList() {
      var modems = this.$store.state.modems;
      var selectedLocation = this.selectedLocation.value;
      var modemData = [];
      modemData.push({ label: "Select Modem", value: "SelectModem" });
      var sortModems = modems.sort(function(a, b) {
        var nameA = a.name.toUpperCase();
        var nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      for (var m in sortModems) {
        if (sortModems[m].insideLocation == selectedLocation) {
          modemData.push({
            label: sortModems[m].name,
            value: sortModems[m].modemId
          });
        }
      }

      if (modemData.length == 1) {
        modemData = [];
        modemData.push({
          label: "No Modem Available",
          value: "noModem"
        });
        this.availableModems = modemData;
        this.selectedModem = {
          label: "No Modem Available",
          value: "noModem"
        };
      } else {
        this.availableModems = modemData;
        this.selectedModem = { label: "Select Modem", value: "SelectModem" };
      }

      this.$emit("disableSave", true);
    },
    sendData() {
      if (this.selectedTimeRange.value == "custom") {
        this.chekInputTimeValidation();
      } else {
        this.returnTrendParams();
      }
    },
    chekInputTimeValidation() {
      var dt = moment(this.selectedStartDate).utc();
      var dt2 = moment(this.selectedEndDate).utc();

      if (!(dt.isValid() && dt2.isValid())) {
        this.$vs.notify({
          title: "Error",
          text: "Please select both dates",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        return;
      } else if (dt.isAfter(dt2)) {
        this.$vs.notify({
          title: "Error",
          text: "Start date cannot be greater than End date",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });

        return;
      } else if (dt2.isBefore(dt)) {
        this.$vs.notify({
          title: "Error",
          text: "End date cannot be less than START DATE.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        return;
      } else if (dt.isAfter(moment())) {
        this.$vs.notify({
          title: "Error",
          text: "Start date cannot be greater than today",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        return;
      } else if (dt2.isAfter(moment())) {
        this.$vs.notify({
          title: "Error",
          text: "End date cannot be greater than today",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        return;
      } else if (dt.isSame(dt2)) {
        this.$vs.notify({
          title: "Error",
          text: "Start date cannot be same as End date ",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        return;
      } else {
        this.returnTrendParams();
      }
    },
    returnTrendParams() {
      var setTimZone = "Asia/Kolkata";
      var timRng = this.selectedTimeRange.value;
      var startTime = "";
      var endTime = "";
      if (timRng == "Last 30 min") {
        startTime = moment()
          .subtract(30, "minutes")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Last hour") {
        startTime = moment()
          .subtract(1, "hours")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Last 4 hour") {
        startTime = moment()
          .subtract(4, "hours")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Last 8 hour") {
        startTime = moment()
          .subtract(8, "hours")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Last 24 hour") {
        startTime = moment()
          .subtract(24, "hours")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Last 7 days") {
        startTime = moment()
          .subtract(6, "days")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Last 30 days") {
        startTime = moment()
          .subtract(29, "days")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Last 3 Month") {
        startTime = moment()
          .subtract(3, "months")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Last 6 Month") {
        startTime = moment()
          .subtract(6, "months")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Day so far") {
        startTime = moment()
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Week so far") {
        startTime = moment()
          .startOf("isoWeek")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Month so far") {
        startTime = moment()
          .startOf("month")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "Year so far") {
        startTime = moment()
          .startOf("year")
          .format("YYYY-MM-DD HH:mm:ss");
        endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (timRng == "custom") {
        var startTimeSub = moment(this.selectedStartDate).valueOf();
        startTime = moment(startTimeSub).format("YYYY-MM-DD HH:mm:ss");
        var endTimeSub = moment(this.selectedEndDate).valueOf();
        endTime = moment(endTimeSub).format("YYYY-MM-DD HH:mm:ss");
      }
      var payload = [
        {
          modemid: this.selectedModem.value,
          tsl: startTime,
          tsh: endTime,
          idxl: 0,
          idxh: 0,
          limit: 100
        },
        { selctedTimerange: timRng }
      ];
      this.$emit("selectedModem", payload);
    }
  },
  components: {
    "v-select": vSelect
  }
};
</script>


